export const appendScriptToDom = (src: string) =>
  new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    // @ts-ignore
    script.onload = () => resolve();
    document.body.appendChild(script);
  });

export const htmlTagDenyList = ['iframe', 'noscript'];

/**
 * removes denied tags, on[event] attributes, and attributes whose values begin with 'javascript:'
 * @constructor
 * @param {string} html the source html (snippet - no body or html tags)
 * @returns {string} the clean (scriptless) html (snippet - no body or html tags)
 */
export const removeScript = (html: string) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const scripts = div.getElementsByTagName('script');
  // remove all script tags
  Array.from(scripts).forEach((script) => {
    script?.parentNode?.removeChild(script);
  });
  // remove denied tags, on[event] attrs, and attrs whose values begin with 'javascript:'
  const elems = div.getElementsByTagName('*');
  Array.from(elems).forEach((element) => {
    if (htmlTagDenyList.includes(element.tagName.toLowerCase())) {
      element?.parentNode?.removeChild(element);
    } else {
      Array.from(element.attributes).forEach((attribute) => {
        // eslint-disable-next-line no-control-regex
        if (
          /^on/i.test(attribute.name) ||
          /^javascript:/i.test(attribute.value.replace(/[^a-z0-9:]/gi, ''))
        ) {
          element.removeAttribute(attribute.name);
        }
      });
    }
  });

  return div.innerHTML;
};

/**
 * removes denied tags, on[event] attributes, and attributes whose values begin with 'javascript:'
 * @constructor
 * @param {string} html the source html (full html document)
 * @returns {string} the clean (scriptless) html (full html document)
 */
export const removeScriptFullDoc = (html: string, csp?: string) => {
  const parser = new DOMParser();
  const serializer = new XMLSerializer();
  const htmlDoc = parser.parseFromString(html, 'text/html');
  const scripts = htmlDoc.getElementsByTagName('script');
  // remove all script tags
  Array.from(scripts).forEach((script) => {
    script?.parentNode?.removeChild(script);
  });
  // remove denied tags, on[event] attrs, and attrs whose values begin with 'javascript:'
  const elems = htmlDoc.getElementsByTagName('*');
  Array.from(elems).forEach((element) => {
    if (htmlTagDenyList.includes(element.tagName.toLowerCase())) {
      element?.parentNode?.removeChild(element);
    } else {
      Array.from(element.attributes).forEach((attribute) => {
        // eslint-disable-next-line no-control-regex
        if (
          /^on/i.test(attribute.name) ||
          /^javascript:/i.test(attribute.value.replace(/[^a-z0-9:]/gi, ''))
        ) {
          element.removeAttribute(attribute.name);
        }
      });
    }
  });
  /*
  This will force all links in the html for the preview to be opened in a new tab, we were seeing errors related to used opening links that would be opened in the browser but this
  was violating security policies around same origin for the iframe.
*/
  const links = htmlDoc.getElementsByTagName('a');
  Array.from(links).forEach((link) => {
    link.setAttribute('target', '_blank');
  });

  // add csp if applicable
  if (csp) {
    const head = htmlDoc.documentElement.getElementsByTagName('head')[0];
    const cspHolder = document.createElement('div');
    cspHolder.innerHTML = csp;
    if (cspHolder.firstChild) {
      head.appendChild(cspHolder.firstChild);
    }
  }

  return serializer.serializeToString(htmlDoc);
};
